import { UiFloatModal } from '../../common/modal/index.js'
import styles from './group.css'


const groupPen = (pen) => `
    <li class="group-pen-wrap" data-Id="${pen.id}">
        <div class="group-pen-block">
            <div class="group-pen-color" style="background: ${pen.color || 'red'}"></div>
            <div class="group-pen-name">${pen.title}</div>
        </div>
        ${pen.main ? `<div class="tooltip-wrap"><div class="main-pen-icon">*</div><div class="tooltip">${i18next.t('trend_group_main_pen_tooltip')}</div></div>` : ''}
    </li>
`

const createOption = (value, selected) => `
    <option value="${value}" ${value === selected ? 'selected' : ''}>${value}</option>
`

const switcher = `
    <svg width="54" height="27" viewBox="0 0 54 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M40.5338 10.125H0V16.875H40.5338V27L54 13.5L40.5338 0V10.125Z" fill="black"/>
    </svg>
`

const icon = `
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 14V13H13V14H14ZM16 14V13H15V14H16ZM6 14V13H5V14H6ZM10 14V13H9V14H10ZM8 14V13H7V14H8ZM8.6 10H12.6L16.7 7.9L16.3 7.1L12.4 9H8.4L4.3 11.1L4.7 11.9L8.6 10ZM12 14V13H11V14H12ZM14 1H13V2H14V1ZM16 1H15V2H16V1ZM12 1H11V2H12V1ZM8 1H7V2H8V1ZM6 1H5V2H6V1ZM8.6 6H12.6L16.7 3.9L16.3 3.1L12.4 5H8.4L4.3 7.1L4.7 7.9L8.6 6ZM10 1H9V2H10V1ZM4 3H3V4H4V3ZM17 10H18V9H17V10ZM17 8H18V7H17V8ZM17 12H18V11H17V12ZM17 14H18V13H17V14ZM17 6H18V5H17V6ZM17 1V2H18V1H17ZM17 4H18V3H17V4ZM4 7H3V8H4V7ZM4 1H3V2H4V1ZM4 5H3V6H4V5ZM4 9H3V10H4V9ZM4 13H3V14H4V13ZM1 0H0V17H18V16H1V0ZM4 11H3V12H4V11Z"/>
    </svg>
`

const template = () => `
    <style>
        ${styles}
    </style>
    <div class="group-main-container">
        <div class="groups-left-wrap">
            <p class="group-title">${i18next.t('trend_group_all_pen')}</p>
            <ul id="group-pens-wrap" class="group-pens-wrap"></ul>
        </div>
        <div id="groups-middle-wrap" class="groups-middle-wrap">
            <div class="group-control" data-dir="right">${switcher}</div>
            <div class="group-control left" data-dir="left">${switcher}</div>
        </div>
        <div class="groups-right-wrap">
            <p class="group-title">${i18next.t('trend_group_title')}</p>
            <div class="group-controls-wrap">
                <div class="group-input-wrap">
                    <div id="no-group" class="no-group" >${i18next.t('trend_group_no_group')}</div>
                    <input id="group-input-name" type="text" class="group-input" />
                    <select id="trend-group-select" class="group-select">
                        <option value="" id="select-default">${i18next.t('trend_group_no_group')}</option>
                    </select>
                    <div id="group-input-color" class="group-input-color"></div>
                </div>
                <div class="control-btns">
                    <div class="tooltip-wrap">
                        <div class="main-pen-icon">
                            <svg id="group-icon-txt" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="18.871" height="18.871" fill="white"/>
                            <path d="M13.4269 16.0327H3.71549V6.14328H9.38046V4.52472H3.71549C2.82528 4.52472 2.09692 5.25307 2.09692 6.14328V15.8547C2.09692 16.7449 2.82528 17.4732 3.71549 17.4732H13.4269C14.3171 17.4732 15.0454 16.7449 15.0454 15.8547V10.1897H13.4269V16.0327Z" fill="black"/>
                            <path d="M15.0454 2.09692H13.4268V4.52477H10.999C11.0071 4.53286 10.999 6.14333 10.999 6.14333H13.4268V8.56308C13.4349 8.57117 15.0454 8.56308 15.0454 8.56308V6.14333H17.4732V4.52477H15.0454V2.09692Z" fill="black"/>
                            <path d="M11.8083 7.76166H5.33405V9.38022H11.8083V7.76166Z" fill="black"/>
                            <path d="M5.33405 10.1898V11.8084H11.8083V10.1898H9.38045H5.33405Z" fill="black"/>
                            <path d="M11.8083 12.6176H5.33405V14.2362H11.8083V12.6176Z" fill="black"/>
                            </svg>
                        </div>
                        <div class="tooltip">${i18next.t('trend_group_create_tooltip')}</div>
                    </div>
                    <div class="tooltip-wrap">
                        <div class="main-pen-icon">
                            <svg id="group-icon-pen" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.0644531" width="18.871" height="18.871" fill="white"/>
                                <path d="M14.278 4.90602L13.3266 3.95461C12.7133 3.3413 11.7147 3.3413 11.1014 3.95461L8.99412 6.06187L2.16125 12.8947V16.0713H5.33787L12.21 9.19917L14.278 7.13122C14.8992 6.51792 14.8992 5.51933 14.278 4.90602ZM4.68525 14.4988H3.73384V13.5474L10.5431 6.73808L11.4945 7.68949L4.68525 14.4988ZM8.45158 16.0713L11.5967 12.9262H16.3145V16.0713H8.45158Z" fill="black"/>
                            </svg>
                        </div>
                        <div class="tooltip">${i18next.t('trend_group_edit_tooltip')}</div>
                    </div>
                    <div class="tooltip-wrap">
                        <div class="main-pen-icon">
                            <svg id="group-icon-bin" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.12915" width="18.871" height="18.871" fill="white"/>
                                <path d="M5.12146 15.1434C5.12146 16.0404 5.84036 16.7742 6.71901 16.7742H13.1092C13.9878 16.7742 14.7067 16.0404 14.7067 15.1434V5.35845H5.12146V15.1434ZM15.5055 2.91221H12.7098L11.911 2.0968H7.91716L7.11839 2.91221H4.32269V4.54304H15.5055V2.91221Z" fill="black"/>
                            </svg>
                        </div>
                        <div class="tooltip">${i18next.t('trend_group_delete_tooltip')}</div>
                    </div>
                </div>
            </div>
            <ul class="group-selected-wrap" id="group-selected-wrap"></ul>
            <div class="group-buttons-wrap">
                <button id="group-btn-apply" class="group-btn">${i18next.t('apply')}</button>
                <button id="group-btn-cancel" class="group-btn">${i18next.t('cancel')}</button>
            </div>
        </div>
    </div>
`

/**
 * @class TrendGroup
 * @classdesc Группы тренда
 * */
export class TrendGroup {
    constructor(root, btn) {
        this.root = root
        this.btn = btn
        this.init()
    }

    async init() {
        this.state = {
            update: false,
            create: false,
            currentGroup: null,
            groups: [],
            pens: [],
            selectedPens: [],
            unselectPens: [],
        }
        this.modal = new UiFloatModal(template())
        if(!this.root.parentHasPopup) this.modal.root.style.zIndex = 10000100
        this.pensContainer = this.modal.modalComponent.querySelector('#group-pens-wrap')
        this.selectedContainer = this.modal.modalComponent.querySelector('#group-selected-wrap')
        this.applyBtn = this.modal.modalComponent.querySelector('#group-btn-apply')
        this.cancelBtn = this.modal.modalComponent.querySelector('#group-btn-cancel')
        this.input = this.modal.modalComponent.querySelector('#group-input-name')
        this.inputColor = this.modal.modalComponent.querySelector('#group-input-color')
        this.select = this.modal.modalComponent.querySelector('#trend-group-select')
        this.noGroup = this.modal.modalComponent.querySelector('#no-group')
        this.bin = this.modal.modalComponent.querySelector('#group-icon-bin')
        this.txt = this.modal.modalComponent.querySelector('#group-icon-txt')
        this.pen = this.modal.modalComponent.querySelector('#group-icon-pen')
        this.controls = this.modal.modalComponent.querySelector('#groups-middle-wrap')
        this.input.addEventListener('change', this.onChangeInput.bind(this))
        this.controls.addEventListener('click', this.onControlsClick.bind(this))
        this.pen.addEventListener('click', this.onUpdateClick.bind(this))
        this.txt.addEventListener('click', this.onCreateClick.bind(this))
        this.pensContainer.addEventListener('click', this.onSourceClick.call(this, 'selectedPens'))
        this.selectedContainer.addEventListener('click', this.onSourceClick.call(this, 'unselectPens'))
        this.selectedContainer.addEventListener('dblclick', this.onDoubleClick.bind(this))
        this.applyBtn.addEventListener('click', this.onOkClick.bind(this))
        this.cancelBtn.addEventListener('click', this.onCancelClick.bind(this))
        this.btn.addEventListener('click', this.toggle.bind(this))
        this.select.addEventListener('change', this.onSelect.bind(this))
        this.bin.addEventListener('click', this.onDelete.bind(this))
        this.modal.modalComponent.calculateInitialPosition = () => {
            const { top, right } = this.root.getBoundingClientRect()
            // 10 - это дополнительный отступ, чтобы не прилипало к верху
            return [right - this.modal.modalComponent.offsetWidth, top + this.root.toolbar.offsetHeight + 10]
        }
        this.btn.innerHTML = icon
        this.modal.modalComponent.label = i18next.t('trend_group_groups_pen')
        this.initPens()
        this.applyBtn.disabled = true; 
    }


    reinit(){
        this.reset()
        this.initPens();
        this.initGroup();
        this.inintCurrentGroup();
        this.root.updateYAxises()
        this.root.updateSeriesAxises();
        this.root.broadcast();
        this.render();
        this.updateInputBlock();
    }

    updateSubmitBtn(){
        if(this.create || this.update){
            if(this.state.selectedPens.length && this.input.value.length){
                this.applyBtn.disabled = false; 
            } else {
                this.applyBtn.disabled = true; 
            }
        } else {
            this.applyBtn.disabled = true; 
        }
    }
    
    reset(){
        this.state.create = false;
        this.state.update = false;
        this.applyBtn.disabled = false;
        this.input.style.display = 'none'
    }

    resetButtons(){
        ["pen", "bin", "txt"].forEach(btn => {
            this[btn].classList.remove("active", "disable");
        });
    };

    setActiveButtons(activeBtn){
        this[activeBtn].classList.add("active");
    };

    setDisableButtons(disableBtns){
        disableBtns.forEach(btn => {
            this[btn].classList.add("disable");
        });
    };

    updateControllBtnsState(){
        this.resetButtons()
        if(this.create){
            this.setActiveButtons("txt");
            this.setDisableButtons(["pen", "bin"]);
            return
        }
        if(this.update){
            this.setActiveButtons("pen");
            this.setDisableButtons(["txt", "bin"]);
            return
        }
        if(!this.pensContainer.children.length){
            this.setDisableButtons(["txt"]);
        }
        if(!this.groups.length){
            this.setDisableButtons(["pen", "bin"]);
        }
    }

    updateInputBlock(){
        if(this.groups.length){
            this.noGroup.style.display = 'none'
            this.select.style.display = 'block'
        } else {
            this.noGroup.style.display = 'block'
            this.select.style.display = 'none'
        }
    }

    initPens() {
        const data = this.root.pens;
        const pens = data.map((p) => ({id: p.source, title: p.name, color: p.color, yformat: p.yformat, yAxis: JSON.parse(JSON.stringify(p.yAxis)), main: p.mainpengroup, groupName: p.groupname || null, selected: p.groupname ? true : false}))
        this.pens = pens
    }

    initGroup(){
        let index = 0;
        const groups = []
        this.pens.forEach((pen) => {
            if(pen.groupName){
                const group = groups.filter((group) => {
                   return group.name === pen.groupName
                })
                if(group.length){
                    if(!group[0].isMainyAxis && pen.main){
                        const yAxis = pen.yAxis
                        yAxis.name = pen.groupName
                        yAxis.yformat = pen.yformat
                        yAxis.nameLocation = "center"
                        if(yAxis.nameTextStyle){
                            yAxis.nameTextStyle.padding = [0, 0, 15, 0]
                            yAxis.nameTextStyle.color = pen.color
                        } else {
                            yAxis.nameTextStyle = {
                                padding: [0, 0, 15, 0],
                                color: pen.color
                            } 
                        }
                        group[0].yAxis = yAxis
                        group[0].isMainyAxis = true
                    }
                } else {
                    const yAxis = pen.yAxis
                        yAxis.name = pen.groupName
                        yAxis.yformat = pen.yformat
                        yAxis.nameLocation = "center"
                        if(yAxis.nameTextStyle){
                            yAxis.nameTextStyle.padding = [0, 0, 15, 0]
                            yAxis.nameTextStyle.color = pen.color
                        } else {
                            yAxis.nameTextStyle = {
                                padding: [0, 0, 15, 0],
                                color: pen.color
                            } 
                        }
                    const newgroup = {
                        name: pen.groupName,
                        yAxis: yAxis,
                        isMainyAxis: pen.main,
                        index
                    }
                    index++;
                    groups.push(newgroup)
                }
            }
        })
        this.yAxis = groups.map((group) => {
            return group.yAxis
        })
        this.groups = groups
    }

    inintCurrentGroup(){
        if(this.groups.length){
            if(this.currentGroup){
                const foundGroup = this.groups.filter((group) => {
                    return group.name === this.currentGroup
                })
                if (!foundGroup.length){
                    this.currentGroup = this.groups[0].name
                }
            } else {
                this.currentGroup = this.groups[0].name
            }
        } 
    }

    render() {
        this.renderSelect()
        this.renderPens()
        this.renderSelected()
        this.updateControllBtnsState();
    }

    clearState() {
        this.state.selectedPens = []
        this.state.unselectPens = []
    }

    renderList(pens, elem) {
        elem.innerHTML = ''
        for (let i = 0; i < pens.length; i++) {
            const template = groupPen(pens[i])
            elem.innerHTML += template
        }
    }

    renderPens() {
        const pens = this.generateFreePens()
        this.renderList(pens, this.pensContainer)
    }

    renderSelected() {
        let pens = []
        if (!this.create) pens = this.pens.filter(pen => pen.selected && this.currentGroup && pen.groupName === this.currentGroup)
        pens.push(...this.pens.filter(pen => pen.selected && !pen.groupName))
        this.renderList(pens, this.selectedContainer)
    }

    renderSelect() {
        if (!this.select || this.update || this.create) return
        this.select.innerHTML = ''
        if (this.groups.length) {
            for (let i = 0; i < this.groups.length; i++) {
                const elem = this.groups[i]
                const option = createOption(elem.name, this.currentGroup)
                this.select.innerHTML += option
            }
        } else {
            const option = createOption('Групп нет', '', '')
            this.select.innerHTML += option
        }
    }

    onDelete(e) {
        if (!this.groups.length || this.create || this.update || !this.currentGroup) return
        this.root.pens.forEach(pen => {
            if(pen.groupname && pen.groupname === this.currentGroup){
                pen.groupname = null
                pen.mainpengroup = false
            }
        })
        this.currentGroup = null
        this.reinit();
        this.root.saveState()
    }

    onSelect(e) {
        const value = e.target.value
        this.currentGroup = value
        this.render()
    }

    onChangeInput(){
        this.updateSubmitBtn();
    }

    onControlsClick(e) {
        if (!this.create && !this.update) return
        const el = e.target.closest('div')
        const direction = el?.getAttribute('data-dir')
        if (!el && !direction) return
        this.generateSelected()
        this.updateSubmitBtn();
        this.render()
    }

    onSourceClick(key) {
        return (e) => {
            if (!this.create && !this.update) return
            const li = e.target.closest('li')
            const Id = li?.getAttribute('data-Id')
            if (!li || !Id) return
            if (this.state[key].includes(Id)) {
                this.state[key] = this.state[key].filter(s => s !== Id)
                li.classList.remove('active')
            } else {
                this.state[key].push(Id)
                li.classList.add('active')
            }
        }
    }

    onDoubleClick(e) {
        if (!this.create && !this.update) return
        const li = e.target.closest('li')
        const Id = li?.getAttribute('data-Id')
        if (!li || !Id) return
        for (let i = 0; i < this.pens.length; i++) {
            const pen = this.pens[i]
            const condition = (this.create && pen.selected && !pen.groupName) ||
                (this.update && pen.groupName === this.currentGroup || !pen.groupName)
            if (!condition) continue
            if (pen.main) pen.main = false
            if (pen.id === Id) pen.main = true
        }
        this.renderSelected()
    }

    onCancelClick(e) {
        if (this.update) this.onUpdateClick(e)
        else if (this.create) this.onCreateClick(e)
        else this.toggle()
    }

    onOkClick(e) {
        if (!this.create && !this.update) return
        if (!this.input.value) return
        if (this.create) this.createGroup()
        else this.updateGroup()
        this.renderSelect()
        this.updateSubmitBtn();
    }

    onUpdateClick(e) {
        if (!this.currentGroup || this.create) return
        this.pens.forEach(pen => {
            if (pen.selected && !pen.groupName) {
                pen.main = false
                pen.selected = false
            }
            if (!pen.selected && pen.groupName === this.currentGroup) pen.selected = true
        })
        const selectedPens = this.pens.filter(pen => pen.groupName === this.currentGroup)
        const hasMain = selectedPens.find(pen => pen.main)
        if (!hasMain && selectedPens[0]) selectedPens[0].main = true
        this.update = !this.update
        this.updateSubmitBtn();
    }

    onCreateClick(e) {
        if (this.update) return
        this.pens.forEach(pen => {
            if (pen.selected && !pen.groupName) {
                pen.main = false
                pen.selected = false
            }
        })
        this.create = !this.create
        this.updateSubmitBtn();
    }

    createGroup() {
        const value = this.input.value
        const exist = this.groupExist(value)
        const selected = this.pens.filter(pen => !pen.groupName && pen.selected)
        if (!selected.length || exist) return
        selected.forEach(pen => {
            for(let i = 0; i < this.root.pens.length; i++){
                if(this.root.pens[i].source === pen.id){
                    this.root.pens[i].groupname = value
                    this.root.pens[i].mainpengroup = pen.main
                }
            }
        })
        this.create = false
        this.currentGroup = value
        this.root.saveState()
        this.reinit()
        if (this.root.legend) this.root.legend.render()
    }

    updateGroup() {
        const selected = this.pens.filter(pen => (!pen.groupName || pen.groupName === this.currentGroup) && pen.selected)
        if (!selected.length) return
        selected.forEach(pen => pen.groupName = this.currentGroup)
        this.root.pens.forEach(pen => {
            if(pen.groupname && pen.groupname === this.currentGroup){
                pen.groupname = null
                pen.mainpengroup = false
            }
        })
        selected.forEach(pen => {
            for(let i = 0; i < this.root.pens.length; i++){
                if(this.root.pens[i].source === pen.id){
                    this.root.pens[i].groupname = this.input.value
                    this.root.pens[i].mainpengroup = pen.main
                }
            }
        })
        this.update = false
        this.currentGroup = this.input.value
        this.reinit();
        this.root.saveState()
        if (this.root.legend) this.root.legend.render()
    }

    groupExist(name) {
        const exist = this.state.groups.find(g => g.name === name)
        return Boolean(exist)
    }

    toggle(e) {
        this.modal.modalComponent.toggle()
        if (!this.modal.modalComponent.active) return
        this.renderPens()
    }

    close(){
        this.modal.modalComponent.close();
    }
    
    deleteModal(){
        this.modal.modalComponent.delete();

    }

    generateFreePens() {
        const result = this.pens.filter(pen => !pen.selected)
        return result
    }

    generateDefaultSelected() {
        const selected = this.pens.filter(pen => this.currentGroup && pen.groupName === this.currentGroup)
        this.state.selectedPens = selected.map(pen => pen.id)
    }

    generateSelected() {
        let selectedPens = []
        const newPens = this.pens.filter(pen => {
            const condition = this.state.selectedPens.includes(pen.id)
            if (condition) pen.selected = true
            return condition
        })
        selectedPens = newPens.filter(pen => {
            const condition = this.state.unselectPens.includes(pen.id)
            if (condition) {
                pen.main = false
                pen.selected = false
            }
            return !condition
        })
        const hasMain = selectedPens.find(pen => pen.main)
        if (!hasMain && selectedPens[0]) selectedPens[0].main = true
        this.state.selectedPens = selectedPens.map(pen => pen.id)
        this.state.unselectPens = []
    }

    destroy() {
        // Удаляем модальное окно
        this.deleteModal()

        // Удаляем обработчики событий
        this.input.removeEventListener('change', this.onChangeInput.bind(this));
        this.controls.removeEventListener('click', this.onControlsClick.bind(this));
        this.pen.removeEventListener('click', this.onUpdateClick.bind(this));
        this.txt.removeEventListener('click', this.onCreateClick.bind(this));
        this.pensContainer.removeEventListener('click', this.onSourceClick.call(this, 'selectedPens'));
        this.selectedContainer.removeEventListener('click', this.onSourceClick.call(this, 'unselectPens'));
        this.selectedContainer.removeEventListener('dblclick', this.onDoubleClick.bind(this));
        this.applyBtn.removeEventListener('click', this.onOkClick.bind(this));
        this.cancelBtn.removeEventListener('click', this.onCancelClick.bind(this));
        this.btn.removeEventListener('click', this.toggle.bind(this));
        this.select.removeEventListener('change', this.onSelect.bind(this));
        this.bin.removeEventListener('click', this.onDelete.bind(this));

        // Удалить ссылки на элементы DOM
        this.modal = null;
        this.pensContainer = null;
        this.selectedContainer = null;
        this.applyBtn = null;
        this.cancelBtn = null;
        this.input = null;
        this.inputColor = null;
        this.select = null;
        this.noGroup = null;
        this.bin = null;
        this.txt = null;
        this.pen = null;
        this.controls = null;
        this.btn = null;

        this.root = null;
    }

    get create() {
        return this.state.create
    }

    set create(v) {
        this.state.create = v;
        if (v) {
            this.select.style.display = 'none'
            this.noGroup.style.display = 'none'
            this.input.style.display = 'block'
            this.input.focus();
            this.clearState()
        } else {
            this.input.style.display = 'none'
            this.updateInputBlock()
            this.clearState()
            this.generateDefaultSelected()
        }
        this.input.value = ''
        this.render()
    }

    get update() {
        return this.state.update
    }

    set update(v) {
        this.state.update = v;
        if (v) {
            this.input.value = this.currentGroup
            this.select.style.display = 'none'
            this.noGroup.style.display = 'none'
            this.input.style.display = 'block'
            this.input.focus();
            this.generateDefaultSelected()
        } else {
            this.input.style.display = 'none'
            this.updateInputBlock()
            this.input.value = ''
            this.clearState()
            this.generateDefaultSelected()
        }
        this.render()
    }

    get pens() {
        return this.state.pens
    }

    set pens(v) {
        this.state.pens = v;
    }

    get currentGroup() {
        return this.state.currentGroup
    }

    set currentGroup(v) {
        this.state.currentGroup = v;
    }

    get group() {
        const group = this.state.groups.find(g => g.id === this.state.currentGroup)
        if (!this.state.currentGroup || !group) return null
        return group
    }
}
